import {
  PropertyListingType,
  PropertyListingViewType,
  PropertyPurposeType,
  PropertySorting,
} from "@/enums/property.enum";
import { SearchContextProps, SearchState } from "./interfaces";
export const DEFAULT_PAGE_SIZE = 20;

export const INITIAL_PAGE = {
  page: 1,
  size: DEFAULT_PAGE_SIZE,
};

export const DEFAULT_SEARCH_STATE: SearchState = {
  view: PropertyListingViewType.LIST,
  listing: {
    type: PropertyListingType.BUY,
    property: null,
  },
  locations: [],
  bathrooms: null,
  bedrooms: null,
  price: { from: null, to: null },
  area: { from: null, to: null },
  amenities: null,
  rentalPeriod: null,
  purpose: PropertyPurposeType.RESIDENTIAL,
  sort: PropertySorting.FEATURED,
  pageParams: INITIAL_PAGE,
  coordinates: null,
  furnishing: null,
  tour: null,
  badges: null,
  agencyId: null,
  referrer: null,
};

export const DEFAULT_CONTEXT_VALUE: SearchContextProps = {
  isInitialized: false,
  ...DEFAULT_SEARCH_STATE,
  state: DEFAULT_SEARCH_STATE,
  toggleBadge: () => {},
  updateBadge: () => {},
  updateCoordinates: () => {},
  toggleBathroom: () => {},
  toggleBedroom: () => {},
  updatePrice: () => {},
  updateArea: () => {},
  toggleAmenity: () => {},
  updateAmenity: () => {},
  clearFilter: () => {},
  handleSearch: () => {},
  updatePageParams: () => {},
  setState: () => {},
  updateState: () => {},
  updateRentalPeriod: () => {},
  updateFurnishing: () => {},
  updateListing: () => {},
  updateLocations: () => {},
  updatePurpose: () => {},
  updateSort: () => {},
  updateView: () => {},
  updateTour: () => {},
};
